import React, { useState } from 'react';
import {
	Input,
	Modal,
	ModalBody,
	ModalHeader,
	Card,
	CardBody,
	Col,
	Row,
	CardHeader,
	Button,
} from 'reactstrap';
import Dropzone from 'react-dropzone';
import { Link } from 'react-router-dom';

import { uploadFiles as onUploadFiles } from '../../slices/thunks';
import { useDispatch } from 'react-redux';
import { filesize } from 'filesize';
import { set } from 'lodash';

export const UploadFileModal = props => {
	const { isOpen, setIsOpen, isEdit, folder_id, setRefetchData } = props;

	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const [selectedFiles, setselectedFiles] = useState([]);
	const [files, setFiles] = useState([]);

	function handleAcceptedFiles(files) {
		files.map(file =>
			Object.assign(file, {
				preview: URL.createObjectURL(file),
				formattedSize: filesize(file.size),
			})
		);
		setselectedFiles([...selectedFiles, ...files]);
	}

	return (
		<Modal
			id='createFileModal'
			isOpen={isOpen}
			toggle={() => {
				setselectedFiles([]);
				setIsOpen(!isOpen);
			}}
			size='sm'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
			tabIndex='-1'
		>
			<ModalHeader
				toggle={() => {
					setselectedFiles([]);
					setIsOpen(!isOpen);
				}}
			>
				{!!isEdit ? 'Cambiar Archivo' : 'Subir Archivo'}
			</ModalHeader>
			<ModalBody>
				<Dropzone
					onDrop={acceptedFiles => {
						handleAcceptedFiles(acceptedFiles);
					}}
				>
					{({ getRootProps, getInputProps }) => (
						<div className='dropzone dz-clickable'>
							<div
								className='dz-message needsclick'
								style={{
									margin: 'auto',
									cursor: 'pointer',
									minHeight: '230px',
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
								}}
								{...getRootProps()}
							>
								<div className='mb-3'>
									<i className='display-4 text-muted ri-upload-cloud-2-fill' />
								</div>
								<input {...getInputProps()} />
								<h4>Drop files here or click to upload.</h4>
							</div>
						</div>
					)}
				</Dropzone>
				<div className='list-unstyled mb-0' id='file-previews'>
					{selectedFiles.map((file, index) => {
						return (
							<Card
								className='mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete'
								key={index + '-file'}
							>
								<div className='p-2'>
									<Row className='align-items-center'>
										<Col className='col-auto'>
											<img
												data-dz-thumbnail=''
												height='80'
												className='avatar-sm rounded bg-light'
												alt={file.name}
												src={file.preview}
											/>
										</Col>
										<Col>
											<Link
												to='#'
												className='text-muted font-weight-bold'
											>
												{file.name}
											</Link>
											<p className='mb-0'>
												<strong>{file.formattedSize}</strong>
											</p>
										</Col>
									</Row>
								</div>
							</Card>
						);
					})}
				</div>
				<Button
					color='primary'
					size='lg'
					className='mt-2 w-100 '
					onClick={() => {
						const formData = new FormData();
						selectedFiles.forEach(file => {
							formData.append('files', file);
						});

						setIsLoading(true);

						dispatch(
							onUploadFiles({
								folder_id,
								formData,
							})
						)
							.then(res => {
								setRefetchData(res.payload);
							})
							.finally(() => {
								setselectedFiles([]);
								setIsLoading(false);
								setIsOpen(!isOpen);
							});
					}}
				>
					{isLoading && (
						<span
							className='spinner-border spinner-border-sm'
							role='status'
							aria-hidden='true'
							style={{ marginRight: '5px' }}
						></span>
					)}
					Subir Archivo
				</Button>
			</ModalBody>
		</Modal>
	);
};
